/* eslint-disable no-unused-vars */
/* eslint-disable no-unsafe-optional-chaining */
import { FunctionComponent, useEffect, useState, useRef } from "react";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import ReportService from "services/report-service";
import { InputText } from "primereact/inputtext";
import { handlingUrlParams } from "Utils/AppUtils";
import CustomerService from "services/customer-service";
import TokenService from "services/TokenService";
import Select from "react-select";
import { Calendar } from "primereact/calendar";
import { Sidebar } from "primereact/sidebar";
import { confirmDialog } from "primereact/confirmdialog";
import { OverlayPanel } from "primereact/overlaypanel";
import { Divider } from "primereact/divider";
import { Dialog } from "primereact/dialog";
import MetaDataEntity from "./metaData";
import Loader from "common/Loader";
import EntityServices from "services/entity-services";
import { setToaster } from "common/toastStore";
import Attachments from "./attachments";
import ProcessLogs from "./processLogs";
import StatusServices from "services/status-service";
import { IReports } from "types/report.type";
import { useParams, useSearchParams } from "react-router-dom";
import moment from "moment";

interface ReportsProps {}

const Reports: FunctionComponent<ReportsProps> = () => {
  const [reportData, setReportData] = useState([]);
  const [loader, setLoader] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [loanReference, setLoanReference] = useState<string>();
  const [name, setName] = useState<string>();
  const [customerList, setCustomerList] = useState([]);
  const [appsList, setAppsList] = useState<string[]>([]);
  const getUserType = TokenService.getLoggedInUserType();
  const getUserDataFromStorage = TokenService.geUserMenu();
  const [rolesList, setRolesList] = useState<string[]>([]);
  const [selectedCustomers, setSelectedCustomers] = useState<string[]>([]);
  const [selectedapps, setSelectedApps] = useState<string[]>([]);
  const [selectedStatus, setSelectedStatus] = useState<string[]>([]);
  const [visibleRight, setVisibleRight] = useState<boolean>(false);
  const [filtersVisible, setFiltersVisible] = useState<boolean>(false);
  const [createdFrom, setCreatedFrom] = useState<Date | null>(null);
  const [createdTo, setCreatedTo] = useState<Date | null>(null);
  const [metaData, setMetaData] = useState<any>();
  const [attachmentData, setAttachmentData] = useState<any>();
  const [attachment, setAttachments] = useState<boolean>(false);
  // const [mileStones, setMileStones] = useState<boolean>(false);
  const [metaList, setMetaList] = useState<boolean>(false);
  const [logsView, setLogsView] = useState<boolean>(false);
  const [logsData, setLogsData] = useState<any>();
  const [showMortgageClasDocs, setShowMortgageClasDocs] =
    useState<boolean>(false);
  const [mortgageClasDocsData, setMortgageClasDocsData] = useState<any[]>([]);
  const [showMissingDocs, setShowMissingDocs] = useState<boolean>(false);
  const [missingDocsData, setMissingDocsData] = useState<any[]>([]);
  const [first1, setFirst1] = useState<number>(0);

  const op = useRef<OverlayPanel>(null);
  const isConfirming = useRef(false);
  const params = useParams();
  const [searchParams] = useSearchParams();
  const appId = [params.id?.replace(/^"(.*)"$/, "$1")];
  const getPrams = params.id?.replace(/^"(.*)"$/, "$1");
  const queryParams = searchParams.get("searchQuery");
  const reportApplicationId = Number(getPrams);
  const isMinNumberReport = [9, 10].includes(reportApplicationId);
  const nameColumnHeader = isMinNumberReport ? "Min Number" : "Name";
  const nameSearchPlaceholder = isMinNumberReport
    ? "Search by Min Number"
    : "Search by Name";

  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 10,
    page: 1,
    sortField: null,
    sortOrder: null,
  });

  const selectedCidsList =
    selectedCustomers && selectedCustomers.length > 0
      ? selectedCustomers.map(function (item: any) {
          return item.value;
        })
      : [];

  const selectedAppIds =
    selectedapps && selectedapps.length > 0
      ? selectedapps.map(function (item: any) {
          return item.value;
        })
      : [];

  const statusIdList =
    selectedStatus && selectedStatus.length > 0
      ? selectedStatus.map(function (item: any) {
          return item.value;
        })
      : [];

  const payload: any = {
    pageNumber: lazyParams.page,
    pageSize: lazyParams.rows,
    referenceNumber: queryParams ? queryParams : loanReference,
    name: queryParams ? queryParams : name,
    includeInactive: true,
    exactMatch: true,
    applicationIds: getUserType
      ? selectedAppIds
      : getPrams === undefined
      ? []
      : appId.map(Number),
    customerIds: getUserType
      ? selectedCidsList
      : [getUserDataFromStorage[0].id],
    statusIds: statusIdList,
    createdDateRange:
      createdFrom || createdTo
        ? {
            fromDate: createdFrom
              ? createdFrom.toISOString().split("T")[0]
              : undefined,
            toDate: createdTo
              ? createdTo.toISOString().split("T")[0]
              : undefined,
          }
        : undefined,
  };

  useEffect(() => {
    const fetchData = async () => {
      let customersList: any = [];
      let appsList: any = [];
      let mainAppsListArray: any = [];
      let rolesOptions: any = [];

      setLoading(true);
      let customers = await CustomerService.getCustomers(
        handlingUrlParams({
          PageNumber: 1,
          PageSize: 10000,
        })
      );
      let statuses = await StatusServices.getStatus();

      if (getUserType) {
        customers.data.forEach((element: { name: string; id: number }) => {
          customersList.push({
            label: element.name,
            value: element.id,
          });
        });

        customers.data?.forEach((element: { customerApplications: any }) => {
          mainAppsListArray.push(...element?.customerApplications);
        });

        mainAppsListArray.forEach((element: any) => {
          appsList.push({
            label: element.application.name,
            value: element.application.id,
          });
        });
      } else {
        getUserDataFromStorage.forEach(
          (element: { name: string; id: number }) => {
            customersList.push({
              label: element.name,
              value: element.id,
            });
          }
        );

        customers.data?.forEach((element: { customerApplications: any }) => {
          mainAppsListArray.push(...element?.customerApplications);
        });

        getUserDataFromStorage[0].applications.forEach(
          (element: { name: string; id: number }) => {
            appsList.push({
              label: element?.name,
              value: element?.id,
            });
          }
        );
      }
      setCustomerList(customersList);

      setAppsList(appsList);

      statuses.data[0].statuses.forEach(
        (element: { name: string; id: number }) => {
          rolesOptions.push({
            label: element.name,
            value: element.id,
          });
        }
      );
      setRolesList(rolesOptions);
      setLoading(false);
    };
    fetchData();
  }, []);

  useEffect(() => {
    loadLazyData(payload);
  }, [lazyParams, params?.id, searchParams.get("searchQuery")]);

  const handleLoanReference = (e: any) => {
    setLoanReference(e.target.value);
  };

  const handleNameChange = (e: any) => {
    setName(e.target.value);
  };

  const handleCustomerChange = (e: any) => {
    setSelectedCustomers(e);
  };

  const loadLazyData = (payload: IReports) => {
    setLoading(true);
    console.log("payload", payload);
    ReportService.getReport(payload)
      .then((response: any) => {
        setReportData(response.data);
        const getHeaders = response.headers;
        const parsedHeaders = JSON.parse(getHeaders["x-pagination"]);
        setTotalRecords(parsedHeaders.TotalCount);
        setLoading(false);
      })
      .catch((e: Error) => {
        setLoading(false);
        console.log(e);
      });
  };

  const onPage = (event: any) => {
    // event["first"] = 0;
    event["page"] = event.page + 1;
    setFirst1(event.first);
    setLazyParams(event);
  };

  const onSort = (event: any) => {
    setLazyParams(event);
  };

  const appsHandleChange = (e: any) => {
    setSelectedApps(e);
  };

  const statusHandleList = (e: any) => {
    setSelectedStatus(e);
  };

  const filterEntities = () => {
    if (getUserType) {
      payload["customerIds"] = selectedCidsList ? selectedCidsList : [];
      payload["applicationIds"] = selectedAppIds ? selectedAppIds : [];
    } else {
      payload["customerIds"] = [getUserDataFromStorage[0].id];
      payload["applicationIds"] = appId.map(Number);
    }
    payload["statusIds"] = statusIdList ? statusIdList : [];
    loadLazyData(payload);
  };

  const isAnyFilterSelected = () => {
    return Boolean(
      (queryParams && queryParams !== "") ||
        (loanReference && loanReference.toString().trim() !== "") ||
        (name && name.toString().trim() !== "") ||
        (selectedCustomers && selectedCustomers.length > 0) ||
        (selectedapps && selectedapps.length > 0) ||
        (selectedStatus && selectedStatus.length > 0) ||
        createdFrom ||
        createdTo
    );
  };

  const exportToExcel = () => {
    if (!isAnyFilterSelected()) return;
    setLoading(true);
    const exportPayload: any = {
      referenceNumber: queryParams ? queryParams : loanReference,
      name: queryParams ? queryParams : name,
      includeInactive: true,
      exactMatch: true,
      applicationIds: getUserType
        ? selectedAppIds
        : getPrams === undefined
        ? []
        : appId.map(Number),
      customerIds: getUserType
        ? selectedCidsList
        : [getUserDataFromStorage[0].id],
      statusIds: statusIdList,
      createdDateRange:
        createdFrom || createdTo
          ? {
              fromDate: createdFrom
                ? createdFrom.toISOString().split("T")[0]
                : undefined,
              toDate: createdTo
                ? createdTo.toISOString().split("T")[0]
                : undefined,
            }
          : undefined,
    };

    EntityServices.exportToExcel(exportPayload)
      .then(async (response: any) => {
        const headers = response.headers || {};
        const disposition =
          headers["content-disposition"] ||
          headers["Content-Disposition"] ||
          "";

        let filename = `Reports_${new Date().toISOString().slice(0, 10)}.csv`;

        if (disposition) {
          const fnStar = disposition.match(
            /filename\*=(?:UTF-8''|utf-8'')?([^;]+)/i
          );

          const fnQuoted = disposition.match(/filename="([^"]+)"/i);

          const fnRaw = disposition.match(/filename=([^;\n]+)/i);

          if (fnStar && fnStar[1]) filename = decodeURIComponent(fnStar[1]);
          else if (fnQuoted && fnQuoted[1]) filename = fnQuoted[1];
          else if (fnRaw && fnRaw[1])
            filename = fnRaw[1].replace(/['"\s]/g, "");
        }

        const contentType =
          headers["content-type"] || "application/octet-stream";

        const renameNameHeaderToMinNumber = (csvText: string) => {
          const [headerLine, ...remainingLines] = csvText.split(/\r?\n/);

          if (!headerLine) {
            return csvText;
          }

          const updatedHeader = headerLine
            .split(",")
            .map((column: string) => {
              const trimmedColumn = column.trim();
              const normalized = trimmedColumn.replace(/^"|"$/g, "");

              if (normalized !== "Name") {
                return column;
              }

              return /^".*"$/.test(trimmedColumn)
                ? '"Min Number"'
                : "Min Number";
            })
            .join(",");

          return [updatedHeader, ...remainingLines].join("\n");
        };

        const isCsvExport =
          String(contentType).toLowerCase().includes("csv") ||
          filename.toLowerCase().endsWith(".csv");

        let exportData = response.data;

        if (isMinNumberReport && isCsvExport) {
          const csvContent =
            typeof response.data === "string"
              ? response.data
              : await new Blob([response.data]).text();

          exportData = renameNameHeaderToMinNumber(csvContent);
        }

        const blob = new Blob([exportData], {
          type: contentType,
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");

        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();

        window.URL.revokeObjectURL(url);
        setToaster({
          severity: "success",
          summary: "Success",
          detail: `Export started: ${filename}`,
        });
      })
      .catch((e: any) => {
        setToaster({
          severity: "error",
          summary: "Error",
          detail: "Export failed",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const clearFilters = () => {
    // reset UI fields
    setLoanReference("");
    setName("");
    setSelectedCustomers([]);
    setSelectedApps([]);
    setSelectedStatus([]);
    setCreatedFrom(null);
    setCreatedTo(null);
    // construct cleared payload and reload immediately
    const clearedPayload: any = {
      pageNumber: 1,
      pageSize: lazyParams.rows,
      referenceNumber: "",
      name: "",
      includeInactive: true,
      exactMatch: true,
      applicationIds: getUserType
        ? []
        : getPrams === undefined
        ? []
        : appId.map(Number),
      customerIds: getUserType ? [] : [getUserDataFromStorage[0].id],
      statusIds: [],
      createdDateRange: undefined,
    };
    setLazyParams({ ...lazyParams, first: 0, page: 1 });
    loadLazyData(clearedPayload);
  };

  const renderActiveStatus = (rowData: any) => {
    return (
      <>
        <div className="flex items-center">
          <Button
            label={rowData.status}
            className="p-button-success p-button-outlined"
            style={{ padding: "5px 15px", fontSize: 12 }}
          />
        </div>
      </>
    );
  };

  const showOverpanel = (e: any, data: any) => {
    setMetaData(data);
    op.current?.toggle(e);
  };

  const showAttachments = () => {
    setLoader(true);
    EntityServices.getAttachments(metaData.id)
      .then((response: any) => {
        setLoader(false);
        if (response.data.length > 0) {
          setVisibleRight(true);
          setMetaList(false);
          setAttachments(true);
          setAttachmentData(response.data);
        } else {
          setVisibleRight(false);
          setToaster({
            severity: "error",
            summary: "Error Message",
            detail: "Data Not found",
          });
        }
      })
      .catch((e: Error) => {
        setLoader(false);
      });
  };

  const reProcessConfirm = (rowData: any, e?: any) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    if (isConfirming.current) return;
    isConfirming.current = true;

    confirmDialog({
      message:
        "Are you sure you want to reprocess Reference Number: " +
        rowData.referenceNumber +
        " and Name: " +
        rowData.name +
        "?",
      header: "Confirm Reprocess",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        EntityServices.reProcess(rowData.id)
          .then((response: any) => {
            setToaster({
              severity: "success",
              summary: "Success",
              detail: "Successfully marked loan for reprocessing",
            });
            // optionally reload data
            loadLazyData(payload);
          })
          .catch((err: any) => {
            setToaster({
              severity: "error",
              summary: "Error",
              detail: "Failed to mark for reprocessing",
            });
          })
          .finally(() => {
            isConfirming.current = false;
          });
      },
      reject: () => {
        isConfirming.current = false;
      },
      onHide: () => {
        isConfirming.current = false;
      },
    });
  };

  const showMetaData = () => {
    setMetaList(true);
    setAttachments(false);
    // setMileStones(false);
    setVisibleRight(true);
  };

  const showMortgageClasDocuments = () => {
    if (!metaData?.id) return;

    setLoader(true);
    EntityServices.getMortgageClasAttachments(metaData.id)
      .then((response: any) => {
        setLoader(false);
        if (response.data && response.data.length > 0) {
          setMortgageClasDocsData(response.data);
          setShowMortgageClasDocs(true);
        } else {
          setMortgageClasDocsData([]);
          setShowMortgageClasDocs(true);
          setToaster({
            severity: "info",
            summary: "Info",
            detail: "No MortgageClas documents found",
          });
        }
      })
      .catch(() => {
        setLoader(false);
        setToaster({
          severity: "error",
          summary: "Error",
          detail: "Failed to load MortgageClas documents",
        });
      });
  };

  const isMissingDocumentsStatus = (rowData: any) => {
    const statusId = Number(rowData?.statusId);
    const normalizedStatus = String(rowData?.status || "")
      .replace(/\s+/g, "")
      .toLowerCase();

    return statusId === 23 || normalizedStatus === "missingdocuments";
  };

  const isMissingAttachmentsStatus = (rowData: any) => {
    const normalizedStatus = String(rowData?.status || "")
      .replace(/\s+/g, "")
      .toLowerCase();

    return normalizedStatus === "missingattachments";
  };

  const showMissingDocuments = () => {
    if (!metaData?.id) return;

    setLoader(true);
    EntityServices.getMortgageClasRequiredDocuments(metaData.id)
      .then((response: any) => {
        setLoader(false);
        const responseData = Array.isArray(response?.data) ? response.data : [];
        const zeroCountDocs = responseData.filter((item: any) => {
          const count = Number(item?.documentCount);
          return Number.isFinite(count) && count === 0;
        });
        setMissingDocsData(zeroCountDocs);
        setShowMissingDocs(true);

        if (!zeroCountDocs.length) {
          setToaster({
            severity: "info",
            summary: "Info",
            detail: "No missing documents with zero count found",
          });
        }
      })
      .catch(() => {
        setLoader(false);
        setToaster({
          severity: "error",
          summary: "Error",
          detail: "Failed to load missing documents",
        });
      });
  };

  const getMissingDocumentLabel = (item: any) => {
    if (typeof item === "string") return item;

    return (
      item?.documentName ||
      item?.name ||
      item?.requiredDocument ||
      item?.missingDocument ||
      item?.document ||
      item?.mortgagePlaceHolder ||
      item?.customerPlaceHolder ||
      "-"
    );
  };

  const reProcessMortgageClasConfirm = (rowData: any) => {
    if (!rowData?.id) return;

    confirmDialog({
      message:
        "Are you sure you want to reprocess validation for Reference Number: " +
        rowData.referenceNumber +
        " and Name: " +
        rowData.name +
        "?",
      header: "Confirm ReProcess Validation",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        EntityServices.reProcessMortgageClas(rowData.id)
          .then(() => {
            setToaster({
              severity: "success",
              summary: "Success",
              detail:
                "Successfully triggered mortgage clas reprocess validation",
            });
            loadLazyData(payload);
          })
          .catch(() => {
            setToaster({
              severity: "error",
              summary: "Error",
              detail: "Failed to trigger reprocess validation",
            });
          });
      },
    });
  };

  const overrideValidationConfirm = (rowData: any) => {
    if (!rowData?.id) return;

    confirmDialog({
      message:
        "Are you sure you want to override missing document validation for Reference Number: " +
        rowData.referenceNumber +
        " and Name: " +
        rowData.name +
        "?",
      header: "Confirm Override Validation",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        EntityServices.overrideMissingDocument(rowData.id)
          .then(() => {
            setToaster({
              severity: "success",
              summary: "Success",
              detail: "Successfully overridden missing document validation",
            });
            loadLazyData(payload);
          })
          .catch(() => {
            setToaster({
              severity: "error",
              summary: "Error",
              detail: "Failed to override validation",
            });
          });
      },
    });
  };

  const canRetryCurrentStep = (rowData: any) => {
    return rowData?.CanRetry === true || rowData?.canRetry === true;
  };

  const retryCurrentStepConfirm = (rowData: any) => {
    if (!rowData?.id) return;

    confirmDialog({
      message:
        "Are you sure you want to retry current step for Reference Number: " +
        rowData.referenceNumber +
        " and Name: " +
        rowData.name +
        "?",
      header: "Confirm Retry Current Step",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        EntityServices.retryCurrentStep(rowData.id)
          .then(() => {
            setToaster({
              severity: "success",
              summary: "Success",
              detail: "Successfully retried current step",
            });
            loadLazyData(payload);
          })
          .catch(() => {
            setToaster({
              severity: "error",
              summary: "Error",
              detail: "Failed to retry current step",
            });
          });
      },
    });
  };

  const renderActions = (rowData: any) => {
    return (
      <>
        <Button
          type="button"
          className="p-button-sm p-button-outlined p-button-rounded p-button-primary"
          icon="pi pi-ellipsis-h"
          aria-label="Bookmark"
          onClick={(e) => showOverpanel(e, rowData)}
        />
        <OverlayPanel ref={op}>
          <div className="flex flex-col">
            <Button
              icon="pi pi-book"
              label="Meta Data"
              className="p-button-info p-button-outlined"
              onClick={() => showMetaData()}
            />
            <Divider />
            <Button
              icon="pi pi-eye"
              label="Attachments"
              className="p-button-help p-button-outlined"
              onClick={() => showAttachments()}
            />
            <Divider />
            {canRetryCurrentStep(metaData) && (
              <>
                <Button
                  icon="pi pi-replay"
                  label="Retry Current Step"
                  className="p-button-warning p-button-outlined"
                  onClick={() => retryCurrentStepConfirm(metaData)}
                />
                <Divider />
              </>
            )}
            {metaData?.application === "Mortgage Clas Validation" && (
              <>
                <Button
                  icon="pi pi-file"
                  label="View MortgageClas Documents"
                  className="p-button-secondary p-button-outlined"
                  onClick={() => showMortgageClasDocuments()}
                />
                <Divider />
                {isMissingDocumentsStatus(metaData) && (
                  <>
                    <Button
                      icon="pi pi-refresh"
                      label="ReProcess Validation"
                      className="p-button-warning p-button-outlined"
                      onClick={() => reProcessMortgageClasConfirm(metaData)}
                    />
                    <Divider />
                    <Button
                      icon="pi pi-check-circle"
                      label="Override Validation"
                      className="p-button-success p-button-outlined"
                      onClick={() => overrideValidationConfirm(metaData)}
                    />
                    <Divider />
                  </>
                )}
                {isMissingDocumentsStatus(metaData) && (
                  <>
                    <Button
                      icon="pi pi-list"
                      label="Show Missing Documents"
                      className="p-button-help p-button-outlined"
                      onClick={() => showMissingDocuments()}
                    />
                    <Divider />
                  </>
                )}
              </>
            )}
            {(metaData?.application === "Investor Delivery" ||
              metaData?.application === "Adhoc Delivery") && (
              <Button
                icon="pi pi-refresh"
                label="Reprocess"
                className="p-button-warning p-button-outlined"
                onClick={(e) => reProcessConfirm(metaData, e)}
              />
            )}
          </div>
        </OverlayPanel>
      </>
    );
  };

  const renderLogs = (rowData: any) => {
    return (
      <>
        <Button
          icon="pi pi-list"
          className="p-button-rounded p-button-secondary p-button-outlined p-button-sm"
          aria-label="Submit"
          onClick={() => showLogsModal(rowData)}
        />
      </>
    );
  };

  const showLogsModal = (data: any) => {
    setLoader(true);
    EntityServices.getProcessLogs(data?.id)
      .then((response: any) => {
        setLoader(false);
        setLogsView(true);
        if (response.data.length > 0) {
          setLogsView(true);
          setLogsData(response.data);
          console.log("response", response.data);
        } else {
          setLogsView(true);
          setToaster({
            severity: "error",
            summary: "Error Message",
            detail: "Data Not found",
          });
        }
      })
      .catch((e: Error) => {
        setLoader(false);
      });
  };

  const renderFilters = () => {
    return (
      <>
        <div className="w-full flex justify-end gap-2">
          <Button
            onClick={exportToExcel}
            label="Export to Excel"
            icon="pi pi-file-excel"
            disabled={!isAnyFilterSelected()}
            className="p-button-sm p-button-outlined p-button-secondary"
          />
          <Button
            onClick={() => setFiltersVisible(true)}
            label="Filters"
            className="p-button-sm p-button-outlined p-button-success"
          />
        </div>
      </>
    );
  };

  const renderCreatedTime = (rowData: any) => {
    return <>{moment(rowData.createdDate).format("MM/DD/YYYY HH:mm a")}</>;
  };

  const renderProcessTime = (rowData: any) => {
    return <>{moment(rowData.updatedDate).format("MM/DD/YYYY HH:mm a")}</>;
  };

  const renderMileStones = (rowData: any) => {
    return (
      <>
        <ul>
          {rowData?.mileStones && rowData?.mileStones.length > 0 ? (
            rowData?.mileStones.map((item: any, index: number) => (
              <>
                <li key={index} className="text-sm w-full flex flex-col py-1">
                  <span>{item.message}:</span>
                  <span className=" text-ellipsis overflow-hidden">
                    {moment(item.messageDate).format("MM/DD/YYYY HH:mm a")}
                  </span>
                </li>
              </>
            ))
          ) : (
            <>NA</>
          )}
        </ul>
      </>
    );
  };

  return (
    <>
      <DataTable
        className="shadow-md"
        scrollHeight="flex"
        value={reportData}
        loading={loading}
        stripedRows
        dataKey="id"
        lazy={true}
        paginator={true}
        filterDisplay="menu"
        responsiveLayout="scroll"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        rowsPerPageOptions={[10, 20, 50, 100]}
        emptyMessage="No Reports found."
        totalRecords={totalRecords}
        rows={lazyParams.rows}
        first={first1}
        onPage={onPage}
        onSort={onSort}
        sortOrder={lazyParams.sortOrder}
        scrollDirection="both"
        style={{ fontSize: 13 }}
        header={renderFilters}
      >
        <Column body={renderLogs} header="Show Logs"></Column>
        <Column field="referenceNumber" header="Loan Number"></Column>
        <Column field="name" header={nameColumnHeader}></Column>
        <Column field="application" header="Application Name"></Column>
        {getUserType ? (
          <Column field="customer" header="Customer Name"></Column>
        ) : null}

        <Column body={renderActiveStatus} header="Status"></Column>
        <Column body={renderMileStones} header="Milestones"></Column>
        <Column body={renderCreatedTime} header="Received Date"></Column>
        <Column body={renderProcessTime} header="Last Process Date"></Column>
        <Column body={renderActions} header="Actions"></Column>
      </DataTable>
      <Sidebar
        visible={filtersVisible}
        position="right"
        onHide={() => setFiltersVisible(false)}
        style={{ width: 520 }}
      >
        {queryParams ? null : (
          <div className="grid grid-cols-1 gap-4">
            <div className="">
              <InputText
                id="loan"
                value={loanReference}
                onChange={(e) => handleLoanReference(e)}
                placeholder="Search by Reference Number"
                className="w-full"
              />
            </div>
            <div className="">
              <InputText
                id="Name"
                value={name}
                onChange={(e) => handleNameChange(e)}
                placeholder={nameSearchPlaceholder}
                className="w-full"
              />
            </div>
            {getUserType ? (
              <Select
                options={customerList}
                placeholder="Select a Customer"
                isMulti
                onChange={(e) => handleCustomerChange(e)}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              />
            ) : null}
            {getUserType ? (
              <Select
                options={appsList}
                isMulti
                placeholder="Select Application"
                defaultValue={appsList[0]}
                onChange={(e) => appsHandleChange(e)}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              />
            ) : null}
            <div className="w-full">
              <label className="text-sm mb-1 block">Created Date Range</label>
              <div className="flex gap-4 items-center">
                <div className="w-1/2">
                  <Calendar
                    value={createdFrom}
                    onChange={(e: any) => setCreatedFrom(e.value)}
                    showIcon
                    className="w-full"
                    dateFormat="mm/dd/yy"
                    placeholder="From"
                  />
                </div>
                <div className="w-1/2">
                  <Calendar
                    value={createdTo}
                    onChange={(e: any) => setCreatedTo(e.value)}
                    showIcon
                    className="w-full"
                    dateFormat="mm/dd/yy"
                    placeholder="To"
                  />
                </div>
              </div>
            </div>

            <Select
              options={rolesList}
              isMulti
              placeholder="Select Status"
              value={selectedStatus}
              onChange={(e) => statusHandleList(e)}
              menuPortalTarget={document.body}
              menuPosition="fixed"
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            />
            <div className="flex gap-4">
              <Button
                onClick={filterEntities}
                label="Apply"
                className="p-button-sm p-button-outlined p-button-success"
              />
              <Button
                onClick={clearFilters}
                label="Clear Filters"
                className="p-button-sm p-button-outlined p-button-warning"
              />
            </div>
          </div>
        )}
      </Sidebar>
      <Sidebar
        visible={visibleRight}
        position="right"
        onHide={() => setVisibleRight(false)}
        style={{ width: 500 }}
      >
        {metaList ? <MetaDataEntity {...metaData} /> : null}
        {attachment ? <Attachments {...[attachmentData]} /> : null}
      </Sidebar>
      <Sidebar
        visible={logsView}
        position="bottom"
        style={{ minHeight: 500 }}
        onHide={() => setLogsView(false)}
      >
        <ProcessLogs logsData={logsData} />
      </Sidebar>

      <Dialog
        header="MortgageClas Documents"
        visible={showMortgageClasDocs}
        style={{ width: "75vw", maxWidth: "1200px" }}
        onHide={() => setShowMortgageClasDocs(false)}
      >
        <DataTable
          value={mortgageClasDocsData}
          stripedRows
          dataKey="id"
          responsiveLayout="scroll"
          emptyMessage="No MortgageClas documents found."
        >
          <Column field="mortgagePlaceHolder" header="MortgagePlaceHolder" />
          <Column field="customerPlaceHolder" header="CustomerPlaceHolder" />
          <Column field="attachmentId" header="AttachmentId" />
          <Column
            field="pageCount"
            header="PageCount"
            body={(rowData: any) =>
              rowData?.pageCount === null || rowData?.pageCount === undefined
                ? "-"
                : rowData.pageCount
            }
          />
          <Column
            field="size"
            header="Size"
            body={(rowData: any) =>
              rowData?.size === null || rowData?.size === undefined
                ? "-"
                : rowData.size
            }
          />
        </DataTable>
      </Dialog>

      <Dialog
        header="Missing Documents"
        visible={showMissingDocs}
        style={{ width: "55vw", maxWidth: "900px" }}
        onHide={() => setShowMissingDocs(false)}
      >
        <DataTable
          value={missingDocsData}
          stripedRows
          dataKey="placeHolder"
          responsiveLayout="scroll"
          emptyMessage="No missing documents found."
        >
          <Column
            field="placeHolder"
            header="Placeholder"
            body={(rowData: any) => rowData?.placeHolder || "-"}
          />
          <Column
            field="documentCount"
            header="Document Count"
            body={(rowData: any) => {
              if (
                rowData?.documentCount === null ||
                rowData?.documentCount === undefined
              ) {
                return "-";
              }

              const count = Number(rowData.documentCount);
              return (
                <span style={{ color: count === 0 ? "#dc2626" : "inherit" }}>
                  {rowData.documentCount}
                </span>
              );
            }}
          />
        </DataTable>
      </Dialog>
      {loader ? <Loader /> : null}
    </>
  );
};

export default Reports;
